import { clamp } from "../utils/clamp";

export class ScrollManager {
  constructor(
    private width: number,
    private height: number,
    private windowWidth: number,
    private windowHeight: number,
    private _playerX: number,
    private _playerY: number,
  ) {}

  set playerX(val: number) {
    this._playerX = val;
  }

  set playerY(val: number) {
    this._playerY = val;
  }

  get containerX() {
    const trans = clamp(
      this._playerX - this.windowWidth / 2,
      0,
      this.width - this.windowWidth,
    );
    return -trans;
  }

  get containerY() {
    const trans = clamp(
      this._playerY - this.windowHeight / 4,
      0,
      this.height - this.windowHeight,
    );
    return -trans;
  }
}
